import { RHFTextField, FormProvider, LocationSelector } from "@app/components";
import { Strings } from "@app/constants";
import { Stack, Typography, useTheme } from "@mui/material";
import { useForm } from "react-hook-form";
import { ContactSoonDialog } from "../../../components/modals/contact-soon-dialog";
import { yupResolver } from "@hookform/resolvers/yup";
import { checkValutionSchema } from "../validators";
import { useDispatch } from "react-redux";
import { carValuation, resetCarValuation } from "../slices";
import { useDialog, useRequestState } from "@app/hooks";
import { selectCarValuationState } from "../selector";
import { useCallback } from "react";
import { LoadingButton } from "@mui/lab";

const CheckValuation = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const evaluationSuccessDialog = useDialog();

  const methods = useForm({
    resolver: yupResolver(checkValutionSchema) as any,
    defaultValues: {
      carNumber: "",
      phone: "",
      state: "",
      city: "",
      zipCode: "",
    },
  });

  const onSubmit = (form: any) => {
    console.log("Check Valuation Form JSON:", JSON.stringify(form, null, 2));
    dispatch(carValuation(form));
  };

  const handleSuccess = useCallback(() => {
    evaluationSuccessDialog.show();
    dispatch(resetCarValuation());
    methods.reset();
  }, [dispatch, evaluationSuccessDialog]);

  const { loading } = useRequestState({
    stateSelector: selectCarValuationState,
    successMessageShown: true,
    errorShown: true,
    onSuccess: handleSuccess,
  });
  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onSubmit)}>
      <Stack>
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            border: `1px solid ${theme.palette.grey[200]}`,
            borderRadius: 5,
            padding: 5,
            m: 5,
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: 22, sm: 24 },
              fontWeight: "bold",
            }}
          >
            {Strings.step.brand.enterYourCarNumber}
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: theme.palette.grey[500], textAlign: "center" }}
          >
            {Strings.step.brand.pleaseProvideYourVehicle}
          </Typography>
          <RHFTextField
            name={"carNumber"}
            placeholder={Strings.step.brand.egDL34AC4564}
            inputProps={{
              style: { textTransform: "uppercase" },
            }}
            sx={{
              mt: 3,
              width: { xs: "100%", sm: "45%" },
            }}
          />
          <RHFTextField
            name="phone"
            placeholder="Phone"
            sx={{
              width: { xs: "100%", sm: "45%" },
            }}
          />

          <Stack sx={{ width: { xs: "100%", sm: "45%" }, my: 1 }}>
            <LocationSelector variant="default" layout="column" />
          </Stack>

          <LoadingButton loading={loading} type="submit" variant="contained">
            {Strings.button.submit}
          </LoadingButton>
        </Stack>
      </Stack>

      <ContactSoonDialog
        open={evaluationSuccessDialog.visible}
        onClose={evaluationSuccessDialog.hide}
      />
    </FormProvider>
  );
};

export { CheckValuation };
